class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

/**
 * 折叠手风琴，适配动画效果
 * 
 * @author Kunn
 */
class AccordionCollapsible extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));

    // initial
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.openAccordion();
    } else {
      this.mainDetailsToggle.classList.remove('accordion-opening');
      this.mainDetailsToggle.style.height = this.summary.clientHeight + 'px';
    }
    const resizeObserver = new ResizeObserver((entries) => this.updateHeight());
    resizeObserver.observe(document.body);
  }

  updateHeight() {
    if (this.mainDetailsToggle.classList.contains('accordion-opening')) {
      this.mainDetailsToggle.style.height = this.content.clientHeight + this.summary.clientHeight + 'px';
    } else {
      this.mainDetailsToggle.style.height = this.summary.clientHeight + 'px';
    }
  }

  onSummaryClick(event) {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    if (isOpen) {
      this.closeAccordion();
      event.preventDefault();
    } else {
      this.openAccordion();
    }
  }

  openAccordion() {
    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.classList.add('accordion-opening');
      this.mainDetailsToggle.style.height = this.content.clientHeight + this.summary.clientHeight + 'px';
      this.summary.setAttribute('aria-expanded', true);
    });
  }

  closeAccordion() {
    this.mainDetailsToggle.classList.remove('accordion-opening');
    this.mainDetailsToggle.style.height = this.summary.clientHeight + 'px';
    this.closeAnimation(this.mainDetailsToggle);
  }

  closeAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        this.mainDetailsToggle.removeAttribute('open');
        if (this.mainDetailsToggle.closest('details[open]')) {
          trapFocus(this.mainDetailsToggle.closest('details[open]'), this.mainDetailsToggle.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('accordion-collapsible', AccordionCollapsible);